module.exports = __webpack_public_path__ + "279473a71bcaf427afd8095524bc59d9.pdf";